































import { defineComponent } from "@vue/composition-api";
import { Location } from "vue-router";
import { User } from "@scrile/api-provider/dist/api/UserProvider";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import BaseAvatar from "@/components/BaseAvatar";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "AvatarDescription",
  components: { BaseIcon, BaseAvatar },
  props: {
    userPublicData: { type: Object as () => UserPublicData | User, required: true },
    avatarSize: { type: Number, default: 56 },
    title: { type: String },
    description: { type: String },
    to: Object as () => Location,
    borderBottom: { type: Boolean, default: false },
    hideOnlineStatus: { type: Boolean, default: false },
    hideBroadcasting: { type: Boolean, default: false },
    showVerifiedIcon: { type: Boolean, default: false },
  },
});
